require('./style.less');


var Marionette = require('marionette');



module.exports = Marionette.ItemView.extend({

    initialize: function( options ) {

        this.channel = options.channel;
        this.searchTerms = options.searchTerms;

    },

    template: require('./template.hbs'),

    serializeData: function() {

        return {
            multipleSearchTerms: this.searchTerms.length > 1,
            searchTerms: this.searchTerms
        };

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/noResultsView/view.js
 ** module id = 646
 ** module chunks = 0
 **/